module.exports = __webpack_public_path__ + "static/media/maldiniTerraza.fabfd9fc.jpg";